import { create } from "mobx-persist";
import { createContext } from "react";

import AuthStore from "./AuthStore";
import DeliveryPinStore from "./DeliveryPinStore";
import NavMenuStore from "./NavMenuStore";

const hydrate = create({});
export class RootStore {
  authStore = new AuthStore(this);

  navMenuStore = new NavMenuStore(this);

  deliveryPinStore = new DeliveryPinStore(this);

  isHydrated = false;

  setIsHydrated = (value: boolean): void => {
    this.isHydrated = value;
  };

  constructor() {
    Promise.all([
      hydrate("currentUser", this.authStore),
      hydrate("deliveryPin", this.deliveryPinStore),
    ]).then(() => {
      this.setIsHydrated(true);
    });
  }
}

export const rootStore = new RootStore();

export const RootStoreContext = createContext(rootStore);
